<template>
  <img :src="avatar" :alt="title" />
</template>

<script>
import axios from 'axios';
export default {
  props: {
    id: String,
    title: String,
  },
  data: () => ({
    avatar: '',
  }),
  methods: {
    getAvatar() {
      axios
        .get(`${process.env.VUE_APP_API_URL}/externalpages/employeravatar/${this.id}`, {
          responseType: `blob`,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(response => {
          const blob = new Blob([response.data], { type: 'image/*' });
          const fileUrl = URL.createObjectURL(blob);
          this.avatar = fileUrl;
        });
    },
  },
  mounted() {
    this.getAvatar();
  },
};
</script>

<style></style>
